import React, { useRef } from 'react';
import { FaPaperPlane } from 'react-icons/fa';

export default function ChatInput({ 
  value = "",
  onChange,
  onSend,
  disabled = false,
  darkMode = false,
  placeholder = "Ask about your SEO...",
  className = ""
}) {
  const textareaRef = useRef(null);

  // Handle send message - now simplified
  const handleSend = () => {
    if (!value.trim()) return;
    onSend(value.trim());
    onChange('');
  };

  // Handle key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div className="relative">
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          rows={1}
          className={`
            w-full px-4 py-3 pr-12 rounded-xl border text-sm resize-none
            ${darkMode 
              ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400' 
              : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
            }
            focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
          style={{
            minHeight: '48px',
            maxHeight: '120px'
          }}
        />
        
        {/* Send Button */}
        <button
          onClick={handleSend}
          disabled={disabled || !value.trim()}
          className={`
            absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-lg transition-all duration-200
            ${value.trim() && !disabled
              ? 'text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:scale-105'
              : darkMode ? 'text-gray-600' : 'text-gray-400'
            }
            disabled:cursor-not-allowed
          `}
        >
          <FaPaperPlane size={14} />
        </button>
      </div>
    </div>
  );
}
